import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "verification-required-sheet" }
const _hoisted_2 = { class: "verification-required-sheet__layout" }
const _hoisted_3 = { class: "verification-required-sheet__panel" }
const _hoisted_4 = { class: "verification-required-sheet__copy" }
const _hoisted_5 = { class: "verification-required-sheet__message" }

import {modalController} from '@ionic/vue';
import VerificationSheet from '@/views/common/VerificationSheet.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'VerificationRequiredSheet',
  props: {
  text: {
    type: String,
    default: 'You must be verified to perform this action.',
  },
},
  setup(__props) {



const startVerification = async () => {
  await modalController.dismiss();

  const sheet = await modalController.create({
    component: VerificationSheet,
    backdropDismiss: false,
    canDismiss: true,
    cssClass: 'verification-fullscreen-modal',
    mode: 'ios',
    id: 'verificationSheet',
  });

  await sheet.present();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("div", {
          "aria-hidden": "true",
          class: "verification-required-sheet__icon"
        }, [
          _createElementVNode("svg", {
            class: "h-5 w-5 fill-current text-brand-black",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512"
          }, [
            _createElementVNode("path", { d: "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" })
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "verification-required-sheet__title" }, "Verification Required", -1)),
          _createElementVNode("p", _hoisted_5, _toDisplayString(__props.text), 1)
        ]),
        _createElementVNode("div", { class: "verification-required-sheet__actions" }, [
          _createElementVNode("button", {
            type: "button",
            class: "verification-required-sheet__cta",
            onClick: startVerification
          }, " Verify now ")
        ])
      ])
    ])
  ]))
}
}

})